import React, { useState, useEffect } from 'react'
import { DashboardLayout, Toaster } from 'components'
import 'assets/scss/billingPortal/modules/commitmentPaySetup/syncDownDebitNotes.scss';
import { Dropdown, Button } from 'components';
import { CustomMonthYearInput } from 'components/customs/form/CustomMonthYearInput';
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { useCustomSelector } from 'hooks';
import { isArrayNotEmpty, isNotNullUndefined } from 'functions';
import useCommitmentPaySetup from 'dataflow/billingPortal/actions/useCommitmentPaySetup.actions';
import { convertISOToMonthYear } from '../commitmentPay/hooks/func_custom';

export default function SyncDownDebitNotes() {

    const [comId, setComId] = useState(0);
    const [monthYear, setMonthYear] = useState();

    const { allComList } = useCustomSelector("accountControl");
    const { getAllComList } = useAccountControlActions();

    let { syncDownDebitNotes_requesting, isSyncDownDebitNotesSuccessfully } = useCustomSelector("commitmentPaySetup");
    const { syncDownDebitNotes } = useCommitmentPaySetup();

    useEffect(() => {
        getAllComList();
    }, []);

    return (
        <DashboardLayout
            headerTitle={"Sync Down Debit Notes"}

            bodyClassName={"sync-down-debit-notes"}
            body={(
                <div className='sync-down-debit-notes__content'>

                    <div className={'sync-down-debit-notes__content-header'}>
                        Sync Down Debit Notes
                    </div>

                    <div className={'sync-down-debit-notes__content-body'}>
                        <div className={"row"}>
                            <div className='col-12 col-lg-5 pb-4'>
                                <CustomMonthYearInput
                                    label={"Month"}
                                    defaultMonthYear={monthYear}
                                    monthYearFromParent={monthYear}
                                    handleOnChange={setMonthYear}
                                />
                            </div>
                            <div className='col-12 col-lg-5 pb-4'>
                                <Dropdown
                                    options={(isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                        let comId = obj?.ComId? obj.ComId:"";
                                        let comName = obj?.ComName? obj?.ComName:"";

                                        return {
                                            label: comId + " - " + comName,
                                            value: comId
                                        };
                                    }):""}
                                    selectedValue_default={comId}
                                    onChange={(value, label) => {
                                        setComId(value)
                                    }}
                                    label={"COM ID"}
                                    isLabelLegend isSearchable isClearable
                                />
                            </div>
                            <div className='col-12 col-lg-2 pt-0 pt-lg-4'>
                                <Button
                                    className={"grab-button__input float-right float-lg-none"}
                                    isLoading={syncDownDebitNotes_requesting}
                                    isDisabled={syncDownDebitNotes_requesting}
                                    handleOnClick={() => {
                                        if(isNotNullUndefined(monthYear)) {
                                            syncDownDebitNotes({
                                                comId: comId,
                                                monthYear: convertISOToMonthYear(monthYear)
                                            })
                                        } else {
                                            Toaster({ type: "info", msg: "Month is not defined" });
                                        }
                                    }}
                                >
                                    Grab
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        />
    )
}